var E=0,_=1e4,A=1,I=50;export{E as CACHE_EXPIRATION_TIME,_ as CACHE_EXPIRATION_TIME_REFERENCE_BOOK,A as DEFAULT_PAGE,I as DEFAULT_PAGE_SIZE};
//# sourceMappingURL=constants.js.map